import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } };

  connect () {
    this.timeout = window.setTimeout(() => window.location.reload(), this.intervalValue);
  }

  disconnect () {
    window.clearTimeout(this.timeout);
  }
}
